import {
  hasSessionFeature,
  hasSessionPermission,
  resolveSessionEnabledFeatures,
  type CompanyAuthSession,
} from '@crv/contracts/auth';
import type { PermissionKey } from '@crv/contracts/permissions';

export type FeatureKey = string;

export interface AccessRequirements {
  feature?: FeatureKey;
  permission?: PermissionKey;
}

export function resolveEnabledFeatures(
  currentUser: CompanyAuthSession | null | undefined,
): string[] {
  return resolveSessionEnabledFeatures(currentUser);
}

export function hasFeature(
  currentUser: CompanyAuthSession | null | undefined,
  feature: FeatureKey,
): boolean {
  return hasSessionFeature(currentUser, feature);
}

export function hasPermission(
  currentUser: CompanyAuthSession | null | undefined,
  permission: PermissionKey,
): boolean {
  return hasSessionPermission(currentUser, permission);
}

export function can(
  currentUser: CompanyAuthSession | null | undefined,
  requirements: AccessRequirements,
): boolean {
  const featureAllowed = requirements.feature ? hasFeature(currentUser, requirements.feature) : true;
  const permissionAllowed = requirements.permission
    ? hasPermission(currentUser, requirements.permission)
    : true;
  return featureAllowed && permissionAllowed;
}
